import SVGProps from 'src/components/icons/config/svg-props' //
// Auto-generated file created by svgr-cli source svg-template.cjs
// Run npm run generate-icons to update
// Do not edit
const SvgInfoIcon = (props: SVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size || '1em'}
    height={props.size || '1em'}
    fill="none"
    viewBox="0 0 64 64"
    role="img"
    className="icon"
    {...props}
  >
    <path
      fill="currentColor"
      d="M31.6 54C43.971 54 54 43.971 54 31.6S43.971 9.2 31.6 9.2 9.2 19.229 9.2 31.6 19.229 54 31.6 54m25.6-22.4c0 14.139-11.461 25.6-25.6 25.6S6 45.739 6 31.6 17.461 6 31.6 6s25.6 11.461 25.6 25.6m-24-3.2v16H30v-16zm.8-4.8h-4.8v-4.8H34z"
    />
  </svg>
)
export default SvgInfoIcon
